module.exports = __webpack_public_path__ + "houses_services.33d8c26c1bc91ed58f06.svg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/images/houses_services.svg
// module id = ../../../../../src/assets/images/houses_services.svg
// module chunks = styles